import { gsap } from 'gsap';

/**
 * Свечение за заголовком героя на странице реферальной программы.
 *
 * В разметке лежат три одинаковых по размеру картинки свечения (.glow-anim) —
 * анимируется только их прозрачность, поэтому браузер не пересчитывает
 * раскладку. Порядок перебора неслучайный: 0 → 1 → 2 → 0 → 2 → 1 → 0
 * возвращается в исходный кадр, поэтому бесконечный повтор не даёт стыка.
 *
 * Ровно три картинки — условие: последовательность жёстко их перечисляет,
 * на другом количестве анимация просто не запускается (и на остальных
 * страницах, где .glow-anim нет, модуль ничего не делает).
 */
export function initGlowAnimation() {
  const images = gsap.utils.toArray('.glow-anim');

  if (images.length !== 3) return;

  const sequence = [0, 1, 2, 0, 2, 1, 0];
  const delay = 0.4;

  gsap.set(images, { opacity: 0 });
  gsap.set(images[0], { opacity: 1 });

  const tl = gsap.timeline({ repeat: -1 });

  for (let i = 1; i < sequence.length; i++) {
    const current = images[sequence[i - 1]];
    const next = images[sequence[i]];

    // Гашение и проявление идут одновременно ('<' — начало предыдущего твина),
    // иначе в стыке кадров свечение пропадало бы совсем.
    tl.to(current, { opacity: 0, duration: 3.5, ease: 'none' }, '>');
    tl.to(next, { opacity: 1, duration: 3.5, ease: 'none' }, '<');
    tl.to({}, { duration: delay });
  }
}
